import React from 'react'
import LeaveCountLayout from './LeaveCountLayout'
import LeaveListLayout from './LeaveListLayout'

const LeaveLayout = () => {
    return (
        <div className="page-container flex flex-col gap-4">
            <LeaveCountLayout vacationCount={5} sickCount={2} />
            <LeaveListLayout />
        </div>
    )
}

export default LeaveLayout
